// Copyright (c) StrangeBee 2024

import { useLocalMessage } from '@Helpers/';
import { THTooltip } from '@Molecules/THTooltip/THTooltip';
import React, { ReactElement } from 'react';
import { ICONS } from '@Constants/iconsApp';

import './ObservableTypeName.scss';

interface ObservableTypeNameProps {
    isAttachment: boolean;
    name: string;
}

const ObservableTypeName = ({ isAttachment, name }: ObservableTypeNameProps): ReactElement => {
    const i = useLocalMessage();
    return (
        <div className="observable-type-name">
            <span>{name}</span>
            {isAttachment && (
                <THTooltip placement="right" title={i('observable-type.list.table.selector.attachment')}>
                    <ICONS.SaveTwoTone />
                </THTooltip>
            )}
        </div>
    );
};

export default ObservableTypeName;
